export const INIT_POST = "INIT_POST";
export const INIT_POSTS = "INIT_POSTS";
export const FETCHING_POSTS_FAILURE = "FETCHING_POSTS_FAILURE";
export const FETCHING_POSTS_REQUEST = "FETCHING_POSTS_REQUEST";
export const FETCHING_POSTS_SUCCESS = "FETCHING_POSTS_SUCCESS";
export const INIT_REGION = "INIT_REGION";
